import * as Sentry from '@sentry/react';
import { AppBootstrap, ConsentProvider, LanguageProvider } from 'App/Providers/games';
import { AnalyticsProvider } from 'App/Services/Analytics';
import { PushProvider } from 'App/Services/Notifications';
import { PwaProvider } from 'App/Services/Pwa';
import ReactDOM from 'react-dom/client';

import App from './App';
import { config, STORAGE_KEY } from './configs';
import { AppContext, AppProvider } from './providers';

const root = ReactDOM.createRoot(document.getElementById('root'), {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
    <AppBootstrap dsn={config.sentryDsn} environment={config.env}>
        <LanguageProvider localeMap={config.localeMap} defaultLanguage={config.defaultLanguage}>
            <ConsentProvider
                localSdkUrl={config.cookieyesLocalSdk}
                remoteSDKUrl={config.cookieyesRemoteSdk}
                sdkSource={config.cookieyesSdkSource}>
                <PushProvider storageKey={STORAGE_KEY} enablePhase>
                    <PwaProvider storageKey={STORAGE_KEY} enablePhase>
                        <AppProvider appConfig={config}>
                            <AnalyticsProvider
                                appContext={AppContext}
                                storageKey={STORAGE_KEY}
                                lpVersion='main'>
                                <App />
                            </AnalyticsProvider>
                        </AppProvider>
                    </PwaProvider>
                </PushProvider>
            </ConsentProvider>
        </LanguageProvider>
    </AppBootstrap>
);
